import { render, staticRenderFns } from "./Block3.vue?vue&type=template&id=5e16c361&scoped=true&"
import script from "./Block3.vue?vue&type=script&lang=js&"
export * from "./Block3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16c361",
  null
  
)

export default component.exports